import classNames from 'classnames'
import React, { useContext } from 'react'
import { OnboardingAsideContext } from 'apps/Onboarding/views/BlueBook/context/OnboardingAsideContext'
import './OnboardingAsideInner.scss'

export const OnboardingAsideInner = (): React.ReactElement => {
  const { asideInfo } = useContext(OnboardingAsideContext)
  const { component, image, title } = asideInfo

  return (
    <>
      <figure className='onboarding-aside-inner__figure'>
        <img
          className={classNames('onboarding-aside-inner__image', image.className)}
          src={image.src}
          alt={image.alt}
          width={276}
          height={248}
        />
      </figure>
      <div className='onboarding-aside-inner__main'>
        <h3 className='onboarding-aside-inner__title'>{title}</h3>
        <div className='onboarding-aside-inner__content'>{component}</div>
      </div>
    </>
  )
}
